import { render, staticRenderFns } from "./FormularioSeguro.vue?vue&type=template&id=31fe832c&scoped=true"
import script from "./FormularioSeguro.vue?vue&type=script&lang=js"
export * from "./FormularioSeguro.vue?vue&type=script&lang=js"
import style0 from "./FormularioSeguro.vue?vue&type=style&index=0&id=31fe832c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fe832c",
  null
  
)

export default component.exports